// extracted by mini-css-extract-plugin
export var baseTextAltGlobal = "content-page-module--base-text-alt--global--bcb81";
export var baseTextGlobal = "content-page-module--base-text--global--b5aaf";
export var bgImage = "content-page-module--bgImage--e7243";
export var blankHeader = "content-page-module--blankHeader--23f44";
export var blankHeaderTitle = "content-page-module--blankHeaderTitle--1323f";
export var blockSpacing100 = "content-page-module--block-spacing-100--0b88f";
export var blockSpacing50 = "content-page-module--block-spacing-50--dbdfc";
export var blockVPadding100 = "content-page-module--block-v-padding-100--650ed";
export var blockVPadding50 = "content-page-module--block-v-padding-50--a6af6";
export var captionTextGlobal = "content-page-module--caption-text--global--7b0be";
export var cmsRenderedContentGlobal = "content-page-module--cms-rendered-content--global--7618f";
export var container = "content-page-module--container--79625";
export var defaultHSpacingGlobal = "content-page-module--default-h-spacing--global--0dd64";
export var fadeInAnimation = "content-page-module--fadeInAnimation--32775";
export var fadeInOnLoadGlobal = "content-page-module--fade-in-on-load--global--74f90";
export var footerBrandLogo = "content-page-module--footerBrandLogo--9c467";
export var footerContainer = "content-page-module--footerContainer--740fc";
export var footerDescription = "content-page-module--footerDescription--0ec29";
export var fullHeightGlobal = "content-page-module--full-height--global--5712f";
export var fullHeightOmittingNavGlobal = "content-page-module--full-height-omitting-nav--global--06eac";
export var header = "content-page-module--header--dcbb9";
export var headingTextGlobal = "content-page-module--heading-text--global--2a238";
export var ingressTextGlobal = "content-page-module--ingress-text--global--230ee";
export var label = "content-page-module--label--6823d";
export var linkColorChangeTransitionGlobal = "content-page-module--link-color-change-transition--global--50d72";
export var mobileNavBarHeight = "85px";
export var pageHeadingTextGlobal = "content-page-module--page-heading-text--global--8fb52";
export var paragraphTextGlobal = "content-page-module--paragraph-text--global--ab066";
export var subheadingTextGlobal = "content-page-module--subheading-text--global--e4b31";
export var subtitle = "content-page-module--subtitle--2b926";
export var titleContainer = "content-page-module--titleContainer--c8e05";